import { render, staticRenderFns } from "./paymentOrder.vue?vue&type=template&id=6314b806&scoped=true"
import script from "./paymentOrder.vue?vue&type=script&lang=js"
export * from "./paymentOrder.vue?vue&type=script&lang=js"
import style0 from "./paymentOrder.vue?vue&type=style&index=0&id=6314b806&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6314b806",
  null
  
)

export default component.exports